import React from 'react';
import PayoutPageContent from '../components/MyProfile/Payout/PayoutPage';



function ProfilePayoutPage() {
  return (
    <>
      <PayoutPageContent />
    </>
  );
}

export default ProfilePayoutPage;
